export const DANGER = "rgb(234,63,57)";
export const PRIMARY = "#1a73e8";
export const WARNING = "orange";

export default {
    DANGER,
    PRIMARY,
    WARNING
}